import React from 'react';
import CollapseSideBarItem from './CollapseSideBarItem';
import { shouldHidePWAInstall } from '@utils/pwaUtils';

/**
 * PWA-aware CollapseSideBarItem wrapper
 * Hides the item if PWA is already installed
 */
const PWACollapseSideBarItem = (props) => {
    // Don't render if PWA is already installed
    if (shouldHidePWAInstall()) {
        return null;
    }

    // Render the normal CollapseSideBarItem if PWA is not installed
    return <CollapseSideBarItem {...props} />;
};

export default PWACollapseSideBarItem;